/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1AudienceAdded } from '../models/V1AudienceAdded';
import { V1AudienceRemoved } from '../models/V1AudienceRemoved';
import { V1CreativeAdded } from '../models/V1CreativeAdded';
import { V1CreativeRemoved } from '../models/V1CreativeRemoved';
import { V1OrderLineAdTypeSet } from '../models/V1OrderLineAdTypeSet';
import { V1OrderLineApproved } from '../models/V1OrderLineApproved';
import { V1OrderLineArchived } from '../models/V1OrderLineArchived';
import { V1OrderLineAuditConditionsSet } from '../models/V1OrderLineAuditConditionsSet';
import { V1OrderLineCPMOverrideRemoved } from '../models/V1OrderLineCPMOverrideRemoved';
import { V1OrderLineCPMOverriden } from '../models/V1OrderLineCPMOverriden';
import { V1OrderLineCPMSet } from '../models/V1OrderLineCPMSet';
import { V1OrderLineClickThroughURLSet } from '../models/V1OrderLineClickThroughURLSet';
import { V1OrderLineCloneRequestFailed } from '../models/V1OrderLineCloneRequestFailed';
import { V1OrderLineCloneRequestSucceeded } from '../models/V1OrderLineCloneRequestSucceeded';
import { V1OrderLineCloned } from '../models/V1OrderLineCloned';
import { V1OrderLineCompleted } from '../models/V1OrderLineCompleted';
import { V1OrderLineCostSet } from '../models/V1OrderLineCostSet';
import { V1OrderLineCreated } from '../models/V1OrderLineCreated';
import { V1OrderLineDeleted } from '../models/V1OrderLineDeleted';
import { V1OrderLineDeployed } from '../models/V1OrderLineDeployed';
import { V1OrderLineDeployedToDestinationRTB } from '../models/V1OrderLineDeployedToDestinationRTB';
import { V1OrderLineDeployedToDestinationStackAdapt } from '../models/V1OrderLineDeployedToDestinationStackAdapt';
import { V1OrderLineDeployedToDestinationXandrCurate } from '../models/V1OrderLineDeployedToDestinationXandrCurate';
import { V1OrderLineDeployedToDestinationXandrInvest } from '../models/V1OrderLineDeployedToDestinationXandrInvest';
import { V1OrderLineDeployedWithConfig } from '../models/V1OrderLineDeployedWithConfig';
import { V1OrderLineDeploymentCancelled } from '../models/V1OrderLineDeploymentCancelled';
import { V1OrderLineDeploymentCancelling } from '../models/V1OrderLineDeploymentCancelling';
import { V1OrderLineDeploymentDestinationSet } from '../models/V1OrderLineDeploymentDestinationSet';
import { V1OrderLineDestinationRTBCreated } from '../models/V1OrderLineDestinationRTBCreated';
import { V1OrderLineDestinationRTBSet } from '../models/V1OrderLineDestinationRTBSet';
import { V1OrderLineDestinationStackAdaptCreated } from '../models/V1OrderLineDestinationStackAdaptCreated';
import { V1OrderLineDestinationStackAdaptSet } from '../models/V1OrderLineDestinationStackAdaptSet';
import { V1OrderLineDestinationXandrCurateCreated } from '../models/V1OrderLineDestinationXandrCurateCreated';
import { V1OrderLineDestinationXandrCurateSet } from '../models/V1OrderLineDestinationXandrCurateSet';
import { V1OrderLineDestinationXandrInvestCreated } from '../models/V1OrderLineDestinationXandrInvestCreated';
import { V1OrderLineDestinationXandrInvestSet } from '../models/V1OrderLineDestinationXandrInvestSet';
import { V1OrderLineDistributionSet } from '../models/V1OrderLineDistributionSet';
import { V1OrderLineEndTimeSet } from '../models/V1OrderLineEndTimeSet';
import { V1OrderLineErroredDeployingToDestinationRTB } from '../models/V1OrderLineErroredDeployingToDestinationRTB';
import { V1OrderLineErroredDeployingToDestinationStackAdapt } from '../models/V1OrderLineErroredDeployingToDestinationStackAdapt';
import { V1OrderLineErroredDeployingToDestinationXandrCurate } from '../models/V1OrderLineErroredDeployingToDestinationXandrCurate';
import { V1OrderLineErroredDeployingToDestinationXandrInvest } from '../models/V1OrderLineErroredDeployingToDestinationXandrInvest';
import { V1OrderLineFreeImpressionsSet } from '../models/V1OrderLineFreeImpressionsSet';
import { V1OrderLineImpressionsPerDaySet } from '../models/V1OrderLineImpressionsPerDaySet';
import { V1OrderLineImpressionsSet } from '../models/V1OrderLineImpressionsSet';
import { V1OrderLineJobIdSet } from '../models/V1OrderLineJobIdSet';
import { V1OrderLineLocked } from '../models/V1OrderLineLocked';
import { V1OrderLineMigrated } from '../models/V1OrderLineMigrated';
import { V1OrderLineMinimumImpressionsSet } from '../models/V1OrderLineMinimumImpressionsSet';
import { V1OrderLineNameSet } from '../models/V1OrderLineNameSet';
import { V1OrderLineNoteAppended } from '../models/V1OrderLineNoteAppended';
import { V1OrderLineNoteDeactivated } from '../models/V1OrderLineNoteDeactivated';
import { V1OrderLineNoteUpdated } from '../models/V1OrderLineNoteUpdated';
import { V1OrderLinePaidSet } from '../models/V1OrderLinePaidSet';
import { V1OrderLinePaused } from '../models/V1OrderLinePaused';
import { V1OrderLinePlayed } from '../models/V1OrderLinePlayed';
import { V1OrderLinePoIdSet } from '../models/V1OrderLinePoIdSet';
import { V1OrderLinePoliticalFieldsSet } from '../models/V1OrderLinePoliticalFieldsSet';
import { V1OrderLinePrepaySet } from '../models/V1OrderLinePrepaySet';
import { V1OrderLineRedeployVerificationFailed } from '../models/V1OrderLineRedeployVerificationFailed';
import { V1OrderLineRefIdSet } from '../models/V1OrderLineRefIdSet';
import { V1OrderLineRejected } from '../models/V1OrderLineRejected';
import { V1OrderLineReviewStarted } from '../models/V1OrderLineReviewStarted';
import { V1OrderLineSegmentConfigSet } from '../models/V1OrderLineSegmentConfigSet';
import { V1OrderLineStartTimeSet } from '../models/V1OrderLineStartTimeSet';
import { V1OrderLineStateSetToActive } from '../models/V1OrderLineStateSetToActive';
import { V1OrderLineStateSetToPaused } from '../models/V1OrderLineStateSetToPaused';
import { V1OrderLineStatusSetToDeploying } from '../models/V1OrderLineStatusSetToDeploying';
import { V1OrderLineStatusSetToDraft } from '../models/V1OrderLineStatusSetToDraft';
import { V1OrderLineStatusSetToPrevious } from '../models/V1OrderLineStatusSetToPrevious';
import { V1OrderLineStepFunctionSet } from '../models/V1OrderLineStepFunctionSet';
import { V1OrderLineTemplateTypeSet } from '../models/V1OrderLineTemplateTypeSet';
import { V1OrderLineUnarchived } from '../models/V1OrderLineUnarchived';
import { V1OrderLineUnlocked } from '../models/V1OrderLineUnlocked';
import { V1OrderLineViantAdelphicConfigurationSet } from '../models/V1OrderLineViantAdelphicConfigurationSet';
import { V1OrderLineViantAdelphicIDsSet } from '../models/V1OrderLineViantAdelphicIDsSet';
import { V1ReviewRequested } from '../models/V1ReviewRequested';
import { HttpFile } from '../http/http';

/**
* Wrapper for the different kinds of events
*/
export class V1OrderLineEvent {
    /**
    * The type of event
    */
    'eventType'?: string;
    'orderLineCreated'?: V1OrderLineCreated;
    'orderLineCloned'?: V1OrderLineCloned;
    'orderLineDeleted'?: V1OrderLineDeleted;
    'orderLinePlayed'?: V1OrderLinePlayed;
    'orderLinePaused'?: V1OrderLinePaused;
    'orderLineFreeImpressionsSet'?: V1OrderLineFreeImpressionsSet;
    'orderLineStatusSetToDraft'?: V1OrderLineStatusSetToDraft;
    'orderLineClickThroughUrlSet'?: V1OrderLineClickThroughURLSet;
    'orderLineReviewStarted'?: V1OrderLineReviewStarted;
    'orderLineRejected'?: V1OrderLineRejected;
    'orderLineApproved'?: V1OrderLineApproved;
    'orderLineDeploymentCancelled'?: V1OrderLineDeploymentCancelled;
    'orderLineDeployed'?: V1OrderLineDeployed;
    'orderLineImpressionsSet'?: V1OrderLineImpressionsSet;
    'orderLineDestinationXandrInvestCreated'?: V1OrderLineDestinationXandrInvestCreated;
    'orderLineDeployedToDestinationXandrInvest'?: V1OrderLineDeployedToDestinationXandrInvest;
    'orderLineErroredDeployingToDestinationXandrInvest'?: V1OrderLineErroredDeployingToDestinationXandrInvest;
    'orderLineDestinationXandrInvestSet'?: V1OrderLineDestinationXandrInvestSet;
    'orderLinePaidSet'?: V1OrderLinePaidSet;
    'orderLinePrepaySet'?: V1OrderLinePrepaySet;
    'orderLineCostSet'?: V1OrderLineCostSet;
    'reviewRequested'?: V1ReviewRequested;
    'creativeAdded'?: V1CreativeAdded;
    'creativeRemoved'?: V1CreativeRemoved;
    'orderLineStartTimeSet'?: V1OrderLineStartTimeSet;
    'orderLineEndTimeSet'?: V1OrderLineEndTimeSet;
    'orderLineImpressionsPerDaySet'?: V1OrderLineImpressionsPerDaySet;
    'orderLineNameSet'?: V1OrderLineNameSet;
    'orderLineRefIdSet'?: V1OrderLineRefIdSet;
    'orderLineAdTypeSet'?: V1OrderLineAdTypeSet;
    'orderLineLocked'?: V1OrderLineLocked;
    'orderLineUnlocked'?: V1OrderLineUnlocked;
    'orderLineDestinationXandrCurateCreated'?: V1OrderLineDestinationXandrCurateCreated;
    'orderLineDestinationXandrCurateSet'?: V1OrderLineDestinationXandrCurateSet;
    'orderLineDeployedToDestinationXandrCurate'?: V1OrderLineDeployedToDestinationXandrCurate;
    'orderLineErroredDeployingToDestinationXandrCurate'?: V1OrderLineErroredDeployingToDestinationXandrCurate;
    'orderLineArchived'?: V1OrderLineArchived;
    'orderLineUnarchived'?: V1OrderLineUnarchived;
    'audienceAdded'?: V1AudienceAdded;
    'audienceRemoved'?: V1AudienceRemoved;
    'orderLineMinimumImpressionsSet'?: V1OrderLineMinimumImpressionsSet;
    'orderLinePoliticalFieldsSet'?: V1OrderLinePoliticalFieldsSet;
    'orderLineCompleted'?: V1OrderLineCompleted;
    'orderLineSegmentConfigSet'?: V1OrderLineSegmentConfigSet;
    'orderLineTemplateTypeSet'?: V1OrderLineTemplateTypeSet;
    'orderLineNoteAppended'?: V1OrderLineNoteAppended;
    'orderLineNoteUpdated'?: V1OrderLineNoteUpdated;
    'orderLineStateSetToActive'?: V1OrderLineStateSetToActive;
    'orderLineStateSetToPaused'?: V1OrderLineStateSetToPaused;
    'orderLineAuditConditionsSet'?: V1OrderLineAuditConditionsSet;
    'orderLineDeploymentCancelling'?: V1OrderLineDeploymentCancelling;
    'orderLineSetToPrevious'?: V1OrderLineStatusSetToPrevious;
    'orderLineStatusSetToDeploying'?: V1OrderLineStatusSetToDeploying;
    'orderLineCpmSet'?: V1OrderLineCPMSet;
    'orderLineDeploymentDestinationSet'?: V1OrderLineDeploymentDestinationSet;
    'orderLineStepFunctionSet'?: V1OrderLineStepFunctionSet;
    'orderLineViantAdelphicConfigurationSet'?: V1OrderLineViantAdelphicConfigurationSet;
    'orderLineDeployedWithConfig'?: V1OrderLineDeployedWithConfig;
    'orderLineViantAdelphicIdsSet'?: V1OrderLineViantAdelphicIDsSet;
    'orderLineNoteDeactivated'?: V1OrderLineNoteDeactivated;
    'orderLineJobIdSet'?: V1OrderLineJobIdSet;
    'orderLinePoIdSet'?: V1OrderLinePoIdSet;
    'orderLineCpmOverriden'?: V1OrderLineCPMOverriden;
    'orderLineCpmOverrideRemoved'?: V1OrderLineCPMOverrideRemoved;
    'orderLineMigrated'?: V1OrderLineMigrated;
    'orderLineDeployedToDestinationStackAdapt'?: V1OrderLineDeployedToDestinationStackAdapt;
    'orderLineErroredDeployingToDestinationStackAdapt'?: V1OrderLineErroredDeployingToDestinationStackAdapt;
    'orderLineDestinationStackAdaptCreated'?: V1OrderLineDestinationStackAdaptCreated;
    'orderLineDeployedToDestinationRtb'?: V1OrderLineDeployedToDestinationRTB;
    'orderLineErroredDeployingToDestinationRtb'?: V1OrderLineErroredDeployingToDestinationRTB;
    'orderLineDestinationRtbCreated'?: V1OrderLineDestinationRTBCreated;
    'orderLineDestinationRtbSet'?: V1OrderLineDestinationRTBSet;
    'orderLineDestinationStackAdaptSet'?: V1OrderLineDestinationStackAdaptSet;
    'orderLineDistributionSet'?: V1OrderLineDistributionSet;
    'orderLineCloneRequestFailed'?: V1OrderLineCloneRequestFailed;
    'orderLineCloneRequestSucceeded'?: V1OrderLineCloneRequestSucceeded;
    'orderLineRedeployVerificationFailed'?: V1OrderLineRedeployVerificationFailed;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "eventType",
            "baseName": "event_type",
            "type": "string",
            "format": ""
        },
        {
            "name": "orderLineCreated",
            "baseName": "order_line_created",
            "type": "V1OrderLineCreated",
            "format": ""
        },
        {
            "name": "orderLineCloned",
            "baseName": "order_line_cloned",
            "type": "V1OrderLineCloned",
            "format": ""
        },
        {
            "name": "orderLineDeleted",
            "baseName": "order_line_deleted",
            "type": "V1OrderLineDeleted",
            "format": ""
        },
        {
            "name": "orderLinePlayed",
            "baseName": "order_line_played",
            "type": "V1OrderLinePlayed",
            "format": ""
        },
        {
            "name": "orderLinePaused",
            "baseName": "order_line_paused",
            "type": "V1OrderLinePaused",
            "format": ""
        },
        {
            "name": "orderLineFreeImpressionsSet",
            "baseName": "order_line_free_impressions_set",
            "type": "V1OrderLineFreeImpressionsSet",
            "format": ""
        },
        {
            "name": "orderLineStatusSetToDraft",
            "baseName": "order_line_status_set_to_draft",
            "type": "V1OrderLineStatusSetToDraft",
            "format": ""
        },
        {
            "name": "orderLineClickThroughUrlSet",
            "baseName": "order_line_click_through_url_set",
            "type": "V1OrderLineClickThroughURLSet",
            "format": ""
        },
        {
            "name": "orderLineReviewStarted",
            "baseName": "order_line_review_started",
            "type": "V1OrderLineReviewStarted",
            "format": ""
        },
        {
            "name": "orderLineRejected",
            "baseName": "order_line_rejected",
            "type": "V1OrderLineRejected",
            "format": ""
        },
        {
            "name": "orderLineApproved",
            "baseName": "order_line_approved",
            "type": "V1OrderLineApproved",
            "format": ""
        },
        {
            "name": "orderLineDeploymentCancelled",
            "baseName": "order_line_deployment_cancelled",
            "type": "V1OrderLineDeploymentCancelled",
            "format": ""
        },
        {
            "name": "orderLineDeployed",
            "baseName": "order_line_deployed",
            "type": "V1OrderLineDeployed",
            "format": ""
        },
        {
            "name": "orderLineImpressionsSet",
            "baseName": "order_line_impressions_set",
            "type": "V1OrderLineImpressionsSet",
            "format": ""
        },
        {
            "name": "orderLineDestinationXandrInvestCreated",
            "baseName": "order_line_destination_xandr_invest_created",
            "type": "V1OrderLineDestinationXandrInvestCreated",
            "format": ""
        },
        {
            "name": "orderLineDeployedToDestinationXandrInvest",
            "baseName": "order_line_deployed_to_destination_xandr_invest",
            "type": "V1OrderLineDeployedToDestinationXandrInvest",
            "format": ""
        },
        {
            "name": "orderLineErroredDeployingToDestinationXandrInvest",
            "baseName": "order_line_errored_deploying_to_destination_xandr_invest",
            "type": "V1OrderLineErroredDeployingToDestinationXandrInvest",
            "format": ""
        },
        {
            "name": "orderLineDestinationXandrInvestSet",
            "baseName": "order_line_destination_xandr_invest_set",
            "type": "V1OrderLineDestinationXandrInvestSet",
            "format": ""
        },
        {
            "name": "orderLinePaidSet",
            "baseName": "order_line_paid_set",
            "type": "V1OrderLinePaidSet",
            "format": ""
        },
        {
            "name": "orderLinePrepaySet",
            "baseName": "order_line_prepay_set",
            "type": "V1OrderLinePrepaySet",
            "format": ""
        },
        {
            "name": "orderLineCostSet",
            "baseName": "order_line_cost_set",
            "type": "V1OrderLineCostSet",
            "format": ""
        },
        {
            "name": "reviewRequested",
            "baseName": "review_requested",
            "type": "V1ReviewRequested",
            "format": ""
        },
        {
            "name": "creativeAdded",
            "baseName": "creative_added",
            "type": "V1CreativeAdded",
            "format": ""
        },
        {
            "name": "creativeRemoved",
            "baseName": "creative_removed",
            "type": "V1CreativeRemoved",
            "format": ""
        },
        {
            "name": "orderLineStartTimeSet",
            "baseName": "order_line_start_time_set",
            "type": "V1OrderLineStartTimeSet",
            "format": ""
        },
        {
            "name": "orderLineEndTimeSet",
            "baseName": "order_line_end_time_set",
            "type": "V1OrderLineEndTimeSet",
            "format": ""
        },
        {
            "name": "orderLineImpressionsPerDaySet",
            "baseName": "order_line_impressions_per_day_set",
            "type": "V1OrderLineImpressionsPerDaySet",
            "format": ""
        },
        {
            "name": "orderLineNameSet",
            "baseName": "order_line_name_set",
            "type": "V1OrderLineNameSet",
            "format": ""
        },
        {
            "name": "orderLineRefIdSet",
            "baseName": "order_line_ref_id_set",
            "type": "V1OrderLineRefIdSet",
            "format": ""
        },
        {
            "name": "orderLineAdTypeSet",
            "baseName": "order_line_ad_type_set",
            "type": "V1OrderLineAdTypeSet",
            "format": ""
        },
        {
            "name": "orderLineLocked",
            "baseName": "order_line_locked",
            "type": "V1OrderLineLocked",
            "format": ""
        },
        {
            "name": "orderLineUnlocked",
            "baseName": "order_line_unlocked",
            "type": "V1OrderLineUnlocked",
            "format": ""
        },
        {
            "name": "orderLineDestinationXandrCurateCreated",
            "baseName": "order_line_destination_xandr_curate_created",
            "type": "V1OrderLineDestinationXandrCurateCreated",
            "format": ""
        },
        {
            "name": "orderLineDestinationXandrCurateSet",
            "baseName": "order_line_destination_xandr_curate_set",
            "type": "V1OrderLineDestinationXandrCurateSet",
            "format": ""
        },
        {
            "name": "orderLineDeployedToDestinationXandrCurate",
            "baseName": "order_line_deployed_to_destination_xandr_curate",
            "type": "V1OrderLineDeployedToDestinationXandrCurate",
            "format": ""
        },
        {
            "name": "orderLineErroredDeployingToDestinationXandrCurate",
            "baseName": "order_line_errored_deploying_to_destination_xandr_curate",
            "type": "V1OrderLineErroredDeployingToDestinationXandrCurate",
            "format": ""
        },
        {
            "name": "orderLineArchived",
            "baseName": "order_line_archived",
            "type": "V1OrderLineArchived",
            "format": ""
        },
        {
            "name": "orderLineUnarchived",
            "baseName": "order_line_unarchived",
            "type": "V1OrderLineUnarchived",
            "format": ""
        },
        {
            "name": "audienceAdded",
            "baseName": "audience_added",
            "type": "V1AudienceAdded",
            "format": ""
        },
        {
            "name": "audienceRemoved",
            "baseName": "audience_removed",
            "type": "V1AudienceRemoved",
            "format": ""
        },
        {
            "name": "orderLineMinimumImpressionsSet",
            "baseName": "order_line_minimum_impressions_set",
            "type": "V1OrderLineMinimumImpressionsSet",
            "format": ""
        },
        {
            "name": "orderLinePoliticalFieldsSet",
            "baseName": "order_line_political_fields_set",
            "type": "V1OrderLinePoliticalFieldsSet",
            "format": ""
        },
        {
            "name": "orderLineCompleted",
            "baseName": "order_line_completed",
            "type": "V1OrderLineCompleted",
            "format": ""
        },
        {
            "name": "orderLineSegmentConfigSet",
            "baseName": "order_line_segment_config_set",
            "type": "V1OrderLineSegmentConfigSet",
            "format": ""
        },
        {
            "name": "orderLineTemplateTypeSet",
            "baseName": "order_line_template_type_set",
            "type": "V1OrderLineTemplateTypeSet",
            "format": ""
        },
        {
            "name": "orderLineNoteAppended",
            "baseName": "order_line_note_appended",
            "type": "V1OrderLineNoteAppended",
            "format": ""
        },
        {
            "name": "orderLineNoteUpdated",
            "baseName": "order_line_note_updated",
            "type": "V1OrderLineNoteUpdated",
            "format": ""
        },
        {
            "name": "orderLineStateSetToActive",
            "baseName": "order_line_state_set_to_active",
            "type": "V1OrderLineStateSetToActive",
            "format": ""
        },
        {
            "name": "orderLineStateSetToPaused",
            "baseName": "order_line_state_set_to_paused",
            "type": "V1OrderLineStateSetToPaused",
            "format": ""
        },
        {
            "name": "orderLineAuditConditionsSet",
            "baseName": "order_line_audit_conditions_set",
            "type": "V1OrderLineAuditConditionsSet",
            "format": ""
        },
        {
            "name": "orderLineDeploymentCancelling",
            "baseName": "order_line_deployment_cancelling",
            "type": "V1OrderLineDeploymentCancelling",
            "format": ""
        },
        {
            "name": "orderLineSetToPrevious",
            "baseName": "order_line_set_to_previous",
            "type": "V1OrderLineStatusSetToPrevious",
            "format": ""
        },
        {
            "name": "orderLineStatusSetToDeploying",
            "baseName": "order_line_status_set_to_deploying",
            "type": "V1OrderLineStatusSetToDeploying",
            "format": ""
        },
        {
            "name": "orderLineCpmSet",
            "baseName": "order_line_cpm_set",
            "type": "V1OrderLineCPMSet",
            "format": ""
        },
        {
            "name": "orderLineDeploymentDestinationSet",
            "baseName": "order_line_deployment_destination_set",
            "type": "V1OrderLineDeploymentDestinationSet",
            "format": ""
        },
        {
            "name": "orderLineStepFunctionSet",
            "baseName": "order_line_step_function_set",
            "type": "V1OrderLineStepFunctionSet",
            "format": ""
        },
        {
            "name": "orderLineViantAdelphicConfigurationSet",
            "baseName": "order_line_viant_adelphic_configuration_set",
            "type": "V1OrderLineViantAdelphicConfigurationSet",
            "format": ""
        },
        {
            "name": "orderLineDeployedWithConfig",
            "baseName": "order_line_deployed_with_config",
            "type": "V1OrderLineDeployedWithConfig",
            "format": ""
        },
        {
            "name": "orderLineViantAdelphicIdsSet",
            "baseName": "order_line_viant_adelphic_ids_set",
            "type": "V1OrderLineViantAdelphicIDsSet",
            "format": ""
        },
        {
            "name": "orderLineNoteDeactivated",
            "baseName": "order_line_note_deactivated",
            "type": "V1OrderLineNoteDeactivated",
            "format": ""
        },
        {
            "name": "orderLineJobIdSet",
            "baseName": "order_line_job_id_set",
            "type": "V1OrderLineJobIdSet",
            "format": ""
        },
        {
            "name": "orderLinePoIdSet",
            "baseName": "order_line_po_id_set",
            "type": "V1OrderLinePoIdSet",
            "format": ""
        },
        {
            "name": "orderLineCpmOverriden",
            "baseName": "order_line_cpm_overriden",
            "type": "V1OrderLineCPMOverriden",
            "format": ""
        },
        {
            "name": "orderLineCpmOverrideRemoved",
            "baseName": "order_line_cpm_override_removed",
            "type": "V1OrderLineCPMOverrideRemoved",
            "format": ""
        },
        {
            "name": "orderLineMigrated",
            "baseName": "order_line_migrated",
            "type": "V1OrderLineMigrated",
            "format": ""
        },
        {
            "name": "orderLineDeployedToDestinationStackAdapt",
            "baseName": "order_line_deployed_to_destination_stack_adapt",
            "type": "V1OrderLineDeployedToDestinationStackAdapt",
            "format": ""
        },
        {
            "name": "orderLineErroredDeployingToDestinationStackAdapt",
            "baseName": "order_line_errored_deploying_to_destination_stack_adapt",
            "type": "V1OrderLineErroredDeployingToDestinationStackAdapt",
            "format": ""
        },
        {
            "name": "orderLineDestinationStackAdaptCreated",
            "baseName": "order_line_destination_stack_adapt_created",
            "type": "V1OrderLineDestinationStackAdaptCreated",
            "format": ""
        },
        {
            "name": "orderLineDeployedToDestinationRtb",
            "baseName": "order_line_deployed_to_destination_rtb",
            "type": "V1OrderLineDeployedToDestinationRTB",
            "format": ""
        },
        {
            "name": "orderLineErroredDeployingToDestinationRtb",
            "baseName": "order_line_errored_deploying_to_destination_rtb",
            "type": "V1OrderLineErroredDeployingToDestinationRTB",
            "format": ""
        },
        {
            "name": "orderLineDestinationRtbCreated",
            "baseName": "order_line_destination_rtb_created",
            "type": "V1OrderLineDestinationRTBCreated",
            "format": ""
        },
        {
            "name": "orderLineDestinationRtbSet",
            "baseName": "order_line_destination_rtb_set",
            "type": "V1OrderLineDestinationRTBSet",
            "format": ""
        },
        {
            "name": "orderLineDestinationStackAdaptSet",
            "baseName": "order_line_destination_stack_adapt_set",
            "type": "V1OrderLineDestinationStackAdaptSet",
            "format": ""
        },
        {
            "name": "orderLineDistributionSet",
            "baseName": "order_line_distribution_set",
            "type": "V1OrderLineDistributionSet",
            "format": ""
        },
        {
            "name": "orderLineCloneRequestFailed",
            "baseName": "order_line_clone_request_failed",
            "type": "V1OrderLineCloneRequestFailed",
            "format": ""
        },
        {
            "name": "orderLineCloneRequestSucceeded",
            "baseName": "order_line_clone_request_succeeded",
            "type": "V1OrderLineCloneRequestSucceeded",
            "format": ""
        },
        {
            "name": "orderLineRedeployVerificationFailed",
            "baseName": "order_line_redeploy_verification_failed",
            "type": "V1OrderLineRedeployVerificationFailed",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1OrderLineEvent.attributeTypeMap;
    }

    public constructor() {
    }
}

